import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { RootState } from '@core/interfaces/root-state';
import { InputTableState } from '@core/interfaces/input-table-state';

import {
  getters as abstract_getters,
  actions as abstract_actions,
  mutations as abstract_mutations,
} from '@core/store/abstract-provider.store';

const state: InputTableState = {
  models: {},
  // extends with new prop and methods here
};
const getters: GetterTree<InputTableState, RootState> = {
  ...abstract_getters,
  // extends with new prop and methods here
};
const actions: ActionTree<InputTableState, RootState> = {
  ...abstract_actions,
  // extends with new prop and methods here
};
const mutations: MutationTree<InputTableState> = {
  ...abstract_mutations,
  // extends with new prop and methods here
};

export const InputTableStoreModule: Module<InputTableState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
